import { lookupCard } from "../../content/index.js";
import { playCard } from "../cards/playCard.js";
import type { Command, GameState } from "../types/index.js";
import { appendLog, appendReshuffleLogIfNeeded } from "../run/log.js";
import { accept, reject } from "./reject.js";

export function handlePlayCard(
  state: GameState,
  command: Extract<Command, { type: "PLAY_CARD" }>,
): GameState {
  if (state.screen !== "case.play" || !state.run?.activeCase) {
    return reject(state, "プロジェクト進行中のみカードを使用できる");
  }

  const before = state.run.hand.find((c) => c.instanceId === command.instanceId);
  const result = playCard(state.run, state.run.activeCase, command.instanceId);
  if (!result.ok) return reject(state, result.reason);

  const cardName = lookupCard(before?.cardId ?? "")?.name ?? "施策";
  let run = appendLog(result.run, {
    phase: result.activeCase.phase,
    kind: "action",
    message: `${cardName}を使用`,
  });
  run = appendReshuffleLogIfNeeded(state.run, run, result.activeCase.phase, result.reshuffled);
  const fieldJudgment = result.activeCase.lastFieldJudgment;
  if (fieldJudgment?.result === "returned-worker") {
    const revealedName = lookupCard(fieldJudgment.cardId)?.name ?? "公開したカード";
    run = appendLog(run, {
      phase: result.activeCase.phase,
      kind: "action",
      message: `現場判断で「${revealedName}」を公開。施策ではないため山札の上に戻した。`,
    });
  }

  return accept({
    ...state,
    run: { ...run, activeCase: result.activeCase },
  });
}
